export default __webpack_public_path__ + "static/media/IconoVehiculo.b07e5c42.png";